export const OAuthGrantTypes = {
  BASIC: 'BASIC',
  PASSWORD: 'PASSWORD',
  AUTHORIZATION_CODE: 'AUTHORIZATION_CODE',
};
